var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 746,
    height: 414,
    viewBox: "0 0 746 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5599_2030)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_d_5599_2030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 225,
    width: 109,
    height: 242,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_d_5599_2030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 263,
    width: 109,
    height: 204,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter2_d_5599_2030)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 355,
    width: 109,
    height: 112,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_d_5599_2030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 225,
    width: 109,
    height: 242,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter4_d_5599_2030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637,
    y: 225,
    width: 109,
    height: 242,
    rx: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M503.848 41.3353C506.011 42.4538 506.011 45.5462 503.848 46.6646L460.996 68.8295C458.266 70.2415 455.431 67.1233 457.096 64.5398L469.286 45.6237C469.924 44.6342 469.924 43.3631 469.286 42.3735L457.097 23.4608C455.432 20.8773 458.267 17.7589 460.997 19.1709L503.848 41.3353Z",
    fill: "#E771B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.618 41.7793C505.42 42.7113 505.42 45.2887 503.618 46.2207L460.767 68.3857C458.492 69.5622 456.129 66.9634 457.517 64.8105L469.706 45.8945C470.45 44.74 470.45 43.257 469.706 42.1025L457.518 23.1895C456.13 21.0366 458.493 18.4386 460.768 19.6152L503.618 41.7793Z",
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5599_2030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 14,
    width: 302,
    height: 60,
    rx: 30,
    fill: "#E771B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.389 33.1818V55H204.833L192.943 37.8693H192.73V55H190.088V33.1818H192.645L204.577 50.3551H204.79V33.1818H207.389ZM218.983 55.3409C217.506 55.3409 216.21 54.9893 215.095 54.2862C213.987 53.5831 213.12 52.5994 212.495 51.3352C211.877 50.071 211.568 48.5937 211.568 46.9034C211.568 45.1989 211.877 43.7109 212.495 42.4396C213.12 41.1683 213.987 40.1811 215.095 39.478C216.21 38.7749 217.506 38.4233 218.983 38.4233C220.46 38.4233 221.753 38.7749 222.861 39.478C223.976 40.1811 224.842 41.1683 225.46 42.4396C226.085 43.7109 226.398 45.1989 226.398 46.9034C226.398 48.5937 226.085 50.071 225.46 51.3352C224.842 52.5994 223.976 53.5831 222.861 54.2862C221.753 54.9893 220.46 55.3409 218.983 55.3409ZM218.983 53.0824C220.105 53.0824 221.028 52.7947 221.753 52.2195C222.477 51.6442 223.014 50.8878 223.362 49.9503C223.71 49.0128 223.884 47.9972 223.884 46.9034C223.884 45.8097 223.71 44.7905 223.362 43.8459C223.014 42.9013 222.477 42.1378 221.753 41.5554C221.028 40.973 220.105 40.6818 218.983 40.6818C217.861 40.6818 216.938 40.973 216.213 41.5554C215.489 42.1378 214.953 42.9013 214.604 43.8459C214.256 44.7905 214.082 45.8097 214.082 46.9034C214.082 47.9972 214.256 49.0128 214.604 49.9503C214.953 50.8878 215.489 51.6442 216.213 52.2195C216.938 52.7947 217.861 53.0824 218.983 53.0824ZM241.827 42.3011L239.568 42.9403C239.426 42.5639 239.217 42.1982 238.94 41.843C238.67 41.4808 238.3 41.1825 237.832 40.9482C237.363 40.7138 236.763 40.5966 236.031 40.5966C235.03 40.5966 234.195 40.8274 233.528 41.2891C232.867 41.7436 232.537 42.3224 232.537 43.0256C232.537 43.6506 232.764 44.1442 233.219 44.5064C233.673 44.8686 234.383 45.1705 235.349 45.4119L237.778 46.0085C239.241 46.3636 240.332 46.907 241.049 47.6385C241.766 48.3629 242.125 49.2969 242.125 50.4403C242.125 51.3778 241.855 52.2159 241.315 52.9545C240.783 53.6932 240.037 54.2756 239.078 54.7017C238.119 55.1278 237.004 55.3409 235.733 55.3409C234.064 55.3409 232.682 54.9787 231.589 54.2543C230.495 53.5298 229.802 52.4716 229.511 51.0795L231.898 50.483C232.125 51.3636 232.555 52.0241 233.187 52.4645C233.826 52.9048 234.66 53.125 235.69 53.125C236.862 53.125 237.793 52.8764 238.481 52.3793C239.177 51.875 239.525 51.2713 239.525 50.5682C239.525 50 239.327 49.5241 238.929 49.1406C238.531 48.75 237.92 48.4588 237.097 48.267L234.369 47.6278C232.871 47.2727 231.77 46.7223 231.067 45.9766C230.371 45.2237 230.023 44.2827 230.023 43.1534C230.023 42.2301 230.282 41.4134 230.8 40.7031C231.326 39.9929 232.04 39.4354 232.942 39.0305C233.851 38.6257 234.881 38.4233 236.031 38.4233C237.65 38.4233 238.922 38.7784 239.845 39.4886C240.775 40.1989 241.436 41.1364 241.827 42.3011ZM259.162 55.3835C258.125 55.3835 257.184 55.1882 256.339 54.7976C255.494 54.3999 254.823 53.8281 254.326 53.0824C253.829 52.3295 253.58 51.4205 253.58 50.3551C253.58 49.4176 253.765 48.6577 254.134 48.0753C254.503 47.4858 254.997 47.0241 255.615 46.6903C256.233 46.3565 256.915 46.108 257.66 45.9446C258.413 45.7741 259.169 45.6392 259.929 45.5398C260.924 45.4119 261.73 45.3161 262.348 45.2521C262.973 45.1811 263.427 45.0639 263.711 44.9006C264.003 44.7372 264.148 44.4531 264.148 44.0483V43.9631C264.148 42.9119 263.861 42.0952 263.285 41.5128C262.717 40.9304 261.854 40.6392 260.696 40.6392C259.496 40.6392 258.555 40.902 257.873 41.4276C257.191 41.9531 256.712 42.5142 256.435 43.1108L254.049 42.2585C254.475 41.2642 255.043 40.4901 255.753 39.9361C256.471 39.375 257.252 38.9844 258.097 38.7642C258.949 38.5369 259.787 38.4233 260.611 38.4233C261.137 38.4233 261.741 38.4872 262.422 38.6151C263.111 38.7358 263.775 38.9879 264.415 39.3714C265.061 39.755 265.597 40.3338 266.023 41.108C266.449 41.8821 266.662 42.919 266.662 44.2188V55H264.148V52.7841H264.02C263.85 53.1392 263.566 53.5192 263.168 53.924C262.77 54.3288 262.241 54.6733 261.581 54.9574C260.92 55.2415 260.114 55.3835 259.162 55.3835ZM259.546 53.125C260.54 53.125 261.378 52.9297 262.06 52.5391C262.749 52.1484 263.267 51.6442 263.616 51.0263C263.971 50.4084 264.148 49.7585 264.148 49.0767V46.7756C264.042 46.9034 263.807 47.0206 263.445 47.1271C263.09 47.2266 262.678 47.3153 262.209 47.3935C261.748 47.4645 261.297 47.5284 260.856 47.5852C260.423 47.6349 260.071 47.6776 259.802 47.7131C259.148 47.7983 258.537 47.9368 257.969 48.1286C257.408 48.3132 256.954 48.5937 256.606 48.9702C256.265 49.3395 256.094 49.8437 256.094 50.483C256.094 51.3565 256.417 52.017 257.064 52.4645C257.717 52.9048 258.544 53.125 259.546 53.125ZM271.251 61.1364V38.6364H273.68V41.2358H273.979C274.163 40.9517 274.419 40.5895 274.746 40.1491C275.079 39.7017 275.555 39.304 276.173 38.956C276.798 38.6009 277.643 38.4233 278.709 38.4233C280.087 38.4233 281.301 38.7678 282.352 39.4567C283.403 40.1456 284.224 41.1222 284.813 42.3864C285.403 43.6506 285.697 45.142 285.697 46.8608C285.697 48.5938 285.403 50.0959 284.813 51.3672C284.224 52.6314 283.407 53.6115 282.363 54.3075C281.319 54.9964 280.115 55.3409 278.751 55.3409C277.7 55.3409 276.859 55.1669 276.226 54.8189C275.594 54.4638 275.108 54.0625 274.767 53.6151C274.426 53.1605 274.163 52.7841 273.979 52.4858H273.766V61.1364H271.251ZM273.723 46.8182C273.723 48.054 273.904 49.1442 274.266 50.0888C274.628 51.0263 275.158 51.7614 275.854 52.294C276.55 52.8196 277.402 53.0824 278.41 53.0824C279.462 53.0824 280.339 52.8054 281.042 52.2514C281.752 51.6903 282.285 50.9375 282.64 49.9929C283.002 49.0412 283.183 47.983 283.183 46.8182C283.183 45.6676 283.006 44.6307 282.65 43.7074C282.302 42.777 281.773 42.0419 281.063 41.5021C280.36 40.9553 279.476 40.6818 278.41 40.6818C277.388 40.6818 276.528 40.9411 275.832 41.4595C275.136 41.9709 274.611 42.6882 274.256 43.6115C273.9 44.5277 273.723 45.5966 273.723 46.8182ZM289.533 61.1364V38.6364H291.962V41.2358H292.26C292.445 40.9517 292.7 40.5895 293.027 40.1491C293.361 39.7017 293.837 39.304 294.454 38.956C295.079 38.6009 295.925 38.4233 296.99 38.4233C298.368 38.4233 299.582 38.7678 300.633 39.4567C301.685 40.1456 302.505 41.1222 303.094 42.3864C303.684 43.6506 303.979 45.142 303.979 46.8608C303.979 48.5938 303.684 50.0959 303.094 51.3672C302.505 52.6314 301.688 53.6115 300.644 54.3075C299.6 54.9964 298.396 55.3409 297.033 55.3409C295.981 55.3409 295.14 55.1669 294.508 54.8189C293.876 54.4638 293.389 54.0625 293.048 53.6151C292.707 53.1605 292.445 52.7841 292.26 52.4858H292.047V61.1364H289.533ZM292.004 46.8182C292.004 48.054 292.185 49.1442 292.547 50.0888C292.91 51.0263 293.439 51.7614 294.135 52.294C294.831 52.8196 295.683 53.0824 296.692 53.0824C297.743 53.0824 298.62 52.8054 299.323 52.2514C300.033 51.6903 300.566 50.9375 300.921 49.9929C301.283 49.0412 301.464 47.983 301.464 46.8182C301.464 45.6676 301.287 44.6307 300.932 43.7074C300.584 42.777 300.055 42.0419 299.344 41.5021C298.641 40.9553 297.757 40.6818 296.692 40.6818C295.669 40.6818 294.81 40.9411 294.114 41.4595C293.418 41.9709 292.892 42.6882 292.537 43.6115C292.182 44.5277 292.004 45.5966 292.004 46.8182ZM310.328 33.1818V55H307.814V33.1818H310.328ZM314.933 55V38.6364H317.447V55H314.933ZM316.211 35.9091C315.721 35.9091 315.299 35.7422 314.944 35.4084C314.596 35.0746 314.422 34.6733 314.422 34.2045C314.422 33.7358 314.596 33.3345 314.944 33.0007C315.299 32.6669 315.721 32.5 316.211 32.5C316.701 32.5 317.12 32.6669 317.468 33.0007C317.824 33.3345 318.001 33.7358 318.001 34.2045C318.001 34.6733 317.824 35.0746 317.468 35.4084C317.12 35.7422 316.701 35.9091 316.211 35.9091ZM328.7 55.3409C327.166 55.3409 325.845 54.9787 324.737 54.2543C323.629 53.5298 322.777 52.532 322.18 51.2607C321.583 49.9893 321.285 48.5369 321.285 46.9034C321.285 45.2415 321.59 43.7749 322.201 42.5036C322.819 41.2251 323.679 40.2273 324.779 39.5099C325.887 38.7855 327.18 38.4233 328.657 38.4233C329.808 38.4233 330.845 38.6364 331.768 39.0625C332.691 39.4886 333.448 40.0852 334.037 40.8523C334.627 41.6193 334.992 42.5142 335.135 43.5369H332.62C332.429 42.7912 332.002 42.1307 331.342 41.5554C330.688 40.973 329.808 40.6818 328.7 40.6818C327.72 40.6818 326.86 40.9375 326.122 41.4489C325.39 41.9531 324.818 42.6669 324.407 43.5902C324.002 44.5064 323.799 45.5824 323.799 46.8182C323.799 48.0824 323.998 49.1832 324.396 50.1207C324.801 51.0582 325.369 51.7862 326.1 52.3047C326.839 52.8232 327.706 53.0824 328.7 53.0824C329.353 53.0824 329.946 52.9688 330.479 52.7415C331.012 52.5142 331.463 52.1875 331.832 51.7614C332.201 51.3352 332.464 50.8239 332.62 50.2273H335.135C334.992 51.1932 334.641 52.0632 334.08 52.8374C333.526 53.6044 332.791 54.2152 331.875 54.6697C330.965 55.1172 329.907 55.3409 328.7 55.3409ZM343.625 55.3835C342.588 55.3835 341.647 55.1882 340.802 54.7976C339.957 54.3999 339.286 53.8281 338.789 53.0824C338.291 52.3295 338.043 51.4205 338.043 50.3551C338.043 49.4176 338.228 48.6577 338.597 48.0753C338.966 47.4858 339.46 47.0241 340.078 46.6903C340.696 46.3565 341.377 46.108 342.123 45.9446C342.876 45.7741 343.632 45.6392 344.392 45.5398C345.387 45.4119 346.193 45.3161 346.811 45.2521C347.436 45.1811 347.89 45.0639 348.174 44.9006C348.465 44.7372 348.611 44.4531 348.611 44.0483V43.9631C348.611 42.9119 348.323 42.0952 347.748 41.5128C347.18 40.9304 346.317 40.6392 345.159 40.6392C343.959 40.6392 343.018 40.902 342.336 41.4276C341.654 41.9531 341.175 42.5142 340.898 43.1108L338.512 42.2585C338.938 41.2642 339.506 40.4901 340.216 39.9361C340.934 39.375 341.715 38.9844 342.56 38.7642C343.412 38.5369 344.25 38.4233 345.074 38.4233C345.6 38.4233 346.203 38.4872 346.885 38.6151C347.574 38.7358 348.238 38.9879 348.877 39.3714C349.524 39.755 350.06 40.3338 350.486 41.108C350.912 41.8821 351.125 42.919 351.125 44.2188V55H348.611V52.7841H348.483C348.313 53.1392 348.029 53.5192 347.631 53.924C347.233 54.3288 346.704 54.6733 346.044 54.9574C345.383 55.2415 344.577 55.3835 343.625 55.3835ZM344.009 53.125C345.003 53.125 345.841 52.9297 346.523 52.5391C347.212 52.1484 347.73 51.6442 348.078 51.0263C348.434 50.4084 348.611 49.7585 348.611 49.0767V46.7756C348.505 46.9034 348.27 47.0206 347.908 47.1271C347.553 47.2266 347.141 47.3153 346.672 47.3935C346.21 47.4645 345.759 47.5284 345.319 47.5852C344.886 47.6349 344.534 47.6776 344.264 47.7131C343.611 47.7983 343 47.9368 342.432 48.1286C341.871 48.3132 341.416 48.5937 341.068 48.9702C340.728 49.3395 340.557 49.8437 340.557 50.483C340.557 51.3565 340.88 52.017 341.527 52.4645C342.18 52.9048 343.007 53.125 344.009 53.125ZM362.831 38.6364V40.767H354.351V38.6364H362.831ZM356.822 34.7159H359.336V50.3125C359.336 51.0227 359.439 51.5554 359.645 51.9105C359.858 52.2585 360.128 52.4929 360.455 52.6136C360.789 52.7273 361.14 52.7841 361.51 52.7841C361.787 52.7841 362.014 52.7699 362.191 52.7415C362.369 52.706 362.511 52.6776 362.618 52.6562L363.129 54.9148C362.959 54.9787 362.721 55.0426 362.415 55.1065C362.11 55.1776 361.723 55.2131 361.254 55.2131C360.544 55.2131 359.848 55.0604 359.166 54.755C358.491 54.4496 357.93 53.9844 357.483 53.3594C357.042 52.7344 356.822 51.946 356.822 50.9943V34.7159ZM366.613 55V38.6364H369.127V55H366.613ZM367.891 35.9091C367.401 35.9091 366.978 35.7422 366.623 35.4084C366.275 35.0746 366.101 34.6733 366.101 34.2045C366.101 33.7358 366.275 33.3345 366.623 33.0007C366.978 32.6669 367.401 32.5 367.891 32.5C368.381 32.5 368.8 32.6669 369.148 33.0007C369.503 33.3345 369.681 33.7358 369.681 34.2045C369.681 34.6733 369.503 35.0746 369.148 35.4084C368.8 35.7422 368.381 35.9091 367.891 35.9091ZM380.38 55.3409C378.902 55.3409 377.606 54.9893 376.491 54.2862C375.383 53.5831 374.517 52.5994 373.892 51.3352C373.274 50.071 372.965 48.5937 372.965 46.9034C372.965 45.1989 373.274 43.7109 373.892 42.4396C374.517 41.1683 375.383 40.1811 376.491 39.478C377.606 38.7749 378.902 38.4233 380.38 38.4233C381.857 38.4233 383.149 38.7749 384.257 39.478C385.372 40.1811 386.239 41.1683 386.857 42.4396C387.482 43.7109 387.794 45.1989 387.794 46.9034C387.794 48.5937 387.482 50.071 386.857 51.3352C386.239 52.5994 385.372 53.5831 384.257 54.2862C383.149 54.9893 381.857 55.3409 380.38 55.3409ZM380.38 53.0824C381.502 53.0824 382.425 52.7947 383.149 52.2195C383.874 51.6442 384.41 50.8878 384.758 49.9503C385.106 49.0128 385.28 47.9972 385.28 46.9034C385.28 45.8097 385.106 44.7905 384.758 43.8459C384.41 42.9013 383.874 42.1378 383.149 41.5554C382.425 40.973 381.502 40.6818 380.38 40.6818C379.257 40.6818 378.334 40.973 377.61 41.5554C376.885 42.1378 376.349 42.9013 376.001 43.8459C375.653 44.7905 375.479 45.8097 375.479 46.9034C375.479 47.9972 375.653 49.0128 376.001 49.9503C376.349 50.8878 376.885 51.6442 377.61 52.2195C378.334 52.7947 379.257 53.0824 380.38 53.0824ZM394.146 45.1562V55H391.632V38.6364H394.061V41.1932H394.274C394.658 40.3622 395.24 39.6946 396.021 39.1903C396.803 38.679 397.811 38.4233 399.047 38.4233C400.155 38.4233 401.124 38.6506 401.955 39.1051C402.786 39.5526 403.433 40.2344 403.894 41.1506C404.356 42.0597 404.587 43.2102 404.587 44.6023V55H402.073V44.7727C402.073 43.4872 401.739 42.4858 401.071 41.7685C400.403 41.044 399.487 40.6818 398.323 40.6818C397.52 40.6818 396.803 40.8558 396.171 41.2038C395.546 41.5518 395.052 42.0597 394.69 42.7273C394.328 43.3949 394.146 44.2045 394.146 45.1562ZM420.772 42.3011L418.513 42.9403C418.371 42.5639 418.162 42.1982 417.885 41.843C417.615 41.4808 417.246 41.1825 416.777 40.9482C416.308 40.7138 415.708 40.5966 414.976 40.5966C413.975 40.5966 413.141 40.8274 412.473 41.2891C411.812 41.7436 411.482 42.3224 411.482 43.0256C411.482 43.6506 411.709 44.1442 412.164 44.5064C412.619 44.8686 413.329 45.1705 414.295 45.4119L416.724 46.0085C418.187 46.3636 419.277 46.907 419.994 47.6385C420.712 48.3629 421.07 49.2969 421.07 50.4403C421.07 51.3778 420.8 52.2159 420.261 52.9545C419.728 53.6932 418.982 54.2756 418.023 54.7017C417.065 55.1278 415.949 55.3409 414.678 55.3409C413.009 55.3409 411.628 54.9787 410.534 54.2543C409.44 53.5298 408.748 52.4716 408.457 51.0795L410.843 50.483C411.07 51.3636 411.5 52.0241 412.132 52.4645C412.771 52.9048 413.606 53.125 414.636 53.125C415.807 53.125 416.738 52.8764 417.427 52.3793C418.123 51.875 418.471 51.2713 418.471 50.5682C418.471 50 418.272 49.5241 417.874 49.1406C417.476 48.75 416.866 48.4588 416.042 48.267L413.315 47.6278C411.816 47.2727 410.715 46.7223 410.012 45.9766C409.316 45.2237 408.968 44.2827 408.968 43.1534C408.968 42.2301 409.227 41.4134 409.746 40.7031C410.271 39.9929 410.985 39.4354 411.887 39.0305C412.796 38.6257 413.826 38.4233 414.976 38.4233C416.596 38.4233 417.867 38.7784 418.79 39.4886C419.721 40.1989 420.381 41.1364 420.772 42.3011Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 14.5,
    width: 301,
    height: 59,
    rx: 29.5,
    stroke: "white",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_5599_2030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 512,
    width: 109,
    height: 467,
    rx: 25,
    fill: "url(#paint0_linear_5599_2030)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5599_2030",
    x: 122,
    y: 222,
    width: 123,
    height: 256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5599_2030",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5599_2030",
    x: 251,
    y: 260,
    width: 123,
    height: 218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5599_2030",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5599_2030",
    x: -7,
    y: 352,
    width: 123,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5599_2030",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5599_2030",
    x: 380,
    y: 222,
    width: 123,
    height: 256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5599_2030",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5599_2030",
    x: 630,
    y: 222,
    width: 123,
    height: 256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5599_2030",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_5599_2030",
    x: 512,
    y: -8,
    width: 109,
    height: 475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_5599_2030"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.719952 0 0 0 0 0.0429824 0 0 0 0 0.483013 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5599_2030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5599_2030",
    x1: 566.5,
    y1: 467,
    x2: 566.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E35EA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDDEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5599_2030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 746,
    height: 414,
    fill: "white",
    transform: "matrix(-1 0 0 1 746 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5599_2030"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 14,
    width: 302,
    height: 60,
    rx: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpResult);
export default __webpack_public_path__ + "static/media/up-result.92c1cfb631a4e5e8b019ce5f468a9166.svg";
export { ForwardRef as ReactComponent };